/* eslint-disable @typescript-eslint/camelcase */
export default {
    audit: 'Audit',
    audit_action: 'Action',
    audit_action_agent_attached: 'Added',
    audit_action_agent_detached: 'Removed',
    audit_action_all: 'All',
    audit_customer: 'Customer',
    audit_empty: 'No changes recorded from the Operator Panel.',
    audit_load_error: 'The audit trail could not be loaded.',
    audit_load_more: 'Load more',
    audit_no_customer: 'No customer selected.',
    audit_performed_by: 'by {user}',
    audit_queue_title: 'Audit of queue {queue}',
    audit_refresh: 'Refresh',
    audit_see_all: 'See full audit trail',
    audit_sentence_agent_attached: '{user} added extension {agent} to queue {queue}',
    audit_sentence_agent_detached: '{user} removed extension {agent} from queue {queue}',
    audit_unknown_date: 'No date',
    close: 'Close',
    internal: 'internal',
    team: 'team',
    dettach_queue: 'Unlink',
    edit: 'Edit',
    confirm: 'Confirm',
    edit_agent: 'Edit agent',
    edit_queue: 'Edit queue',
    queue_dids: 'Numbers routing to this queue',
    extension_number: 'Extension number',
    nothing_selected: 'Nothing selected',
    queue: 'Queue | Queues',
    assign_queue: 'Assign queue',
    assignament_queue_description: 'Here you can assign to agent {agent} the next queues:',
    agents: 'Agents',
    more_detail: 'More detail',
    hangup: 'Hangup',
    hangup_call: 'Hangup call',
    ringing: 'Ringing',
    do_not_disturb: 'Do not disturb',
    dnd: 'Do not disturb',
    do_available: 'Do available',
    do_not_show_anymore: 'Do not show anymore',
    panel_settings: 'Panel settings',
    visual_panel_settings: 'Visual panel settings',
    waiting_calls: 'There is at least 1 waiting call in these queues:',
    waiting_calls_activate: 'See notifications for waiting calls',
    no_answer: 'No answer',
    call: {
        incoming: 'Incoming',
        in_progress: 'In progress',
    },
    agent: {
        form: {
            name: 'Name',
            edit_description: 'Here you can edit some attributes of the agent {agent}:',
        },
        agent: 'Agent | Agents',
        paused: 'Paused',
        paused_in_queues: 'Paused in: {queues}',
        status: {
            logged_out: 'Logged out',
            available: 'Available',
            available_on_demand: 'Modo directo',
            on_break: 'On break',
            not_assign: 'Not assigned',
        },
        state: {
            idle: 'Idle',
            waiting: 'Waiting',
            receiving: 'Receiving',
            in_queue_call: 'In queue call',
            ready: 'Resume agent',
            absent: 'Pause agent',
        },
        custom_status: {
            busy: 'Busy',
            available: 'Available',
            unavailable: 'Unavailable',
            agitated: 'Ringing',
            online: 'Online',
            break: 'On break',
            offline: 'Offline',
        },
        timeline: {
            title: 'History',
            description: 'Latest activity of {agent} in the last 24 hours:',
            loading: 'Loading history...',
            empty: 'No activity recorded.',
            status: 'Status: {status}',
            dnd_enabled: 'Paused',
            dnd_enabled_with_reason: 'Paused: {reason}',
            dnd_disabled: 'Back from pause',
            tier_standby: 'Paused in {queue}',
            tier_ready: 'Active in {queue}',
            call_in: 'Answered call from {queue} — {number}',
            call_in_ended: 'Ended call from {queue}',
            call_out: 'Called {number}',
            call_out_ended: 'Ended outbound call',
            registered: 'Connected',
            unregistered: 'Disconnected',
        },
    },
    callcenter: {
        attention_level: 'Attention level',
        abandoned: 'Abandoned',
        abandoned_rate: 'Abandoned rate',
        answered: 'Answered',
        average_talk_seconds: 'Avg. Talk',
        average_wait_seconds: 'Avg. Wait',
        service_level: 'Service level',
        logins: 'Logins',
        logoff: 'Logoff',
        max_wait_time_seconds: 'Max wait',
        received: 'Received',
        transferred: 'Transferred',
        unanswered: 'Unanswered',
        calls_not_answered_within_20_seconds: 'Abandoned > threshold',
        calls_answered_within_10_seconds: 'Answered < threshold',
    },
};
